import React from 'react';
import _ from 'lodash';
import InputCurrencyField from '../../Fields/InputCurrencyField';
import InvoiceLineItem from "../../../Entities/InvoiceLineItem";
import LineItemEntry from "../../../Entities/LineItemEntry";
import InvoiceValidator from "../../../Validators/Invoice";
import './NewCarryoverLineItemPanel.scss';

import InputSelectField from "../../Fields/InputSelectField";
import featureFlags from "../../../featureFlags";

class NewCarryoverLineItemPanel extends React.Component {
  state = {
    lineItem: []
  }

  amountValidator = (value) => InvoiceValidator.validateAmount(value);

  amountValidatorText = (
    <div className="parkchirp--carryover-entry-table--error-amountValidatorText">
      Amount must be POSITIVE.
    </div>
  )

  grossValidator = (value) => !this.props.hasChanged || InvoiceValidator.validateGross(value);

  _onLineItemEntryValueChange = (inputId, lineItemIndex, entryIndex) => {
    return (value, valid = null) => {
      const item = _.cloneDeep( featureFlags.CARRYOVER_RATE ? this.props.lineItems[lineItemIndex] : this.props.lineItems);
      item.fields.entries.value[entryIndex].fields[inputId].value = value;
      if (valid !== null) {
        item.fields.entries.value[entryIndex].fields[inputId].valid = valid;
      }
      const grossAmount = item.fields.entries.value[entryIndex].getGrossAmount();
      item.fields.entries.value[entryIndex].fields.gross_amount = {
        value: grossAmount,
        valid: this.grossValidator(grossAmount)
      };
      this.props.onLineItemChange(lineItemIndex, item);
    }
  }

  _onLineItemValueChange = (lineItemIndex, inputId) => {
    return value => {
      const item = _.cloneDeep(this.props.lineItems[lineItemIndex]);
      item.fields[inputId].value = value;

      this.props.onLineItemChange(lineItemIndex, item);
    }
  }

  _onAddLineItemClick = () => {
    const lineItem = new InvoiceLineItem();
    const lineItemEntry = new LineItemEntry();
    lineItemEntry.fields.type.value = 'CHARGE';
    lineItem.fields.line_item_rate_type.value = 'MONTHLY';
    lineItem.fields.entries.value.push(lineItemEntry);
    this.props.onLineItemChange(null, lineItem);
  }

  handleDeleteLineItem = (lineItemIndex) => {
    const filteredLineItems = this.props.lineItems.filter((item, index) => index !== lineItemIndex);
    this.props.onLineItemDelete(filteredLineItems);
    return filteredLineItems;
  }

  render() {
    const { inputId, lineItems, lineItemConfig, newMode, taxExempt } = this.props;

    return (
      <div className="parkchirp--carryover-entry-table">
        <header className="parkchirp--carryover-entry-table--header">
          <div className="parkchirp--carryover-entry-table--leading-spacer-column"></div>
          {featureFlags.CARRYOVER_RATE &&
            <div className="parkchirp--carryover-entry-table--line-item-rate-type-column parkchirp--carryover-entry-table--cell">
              <span className="parkchirp--carryover-entry-table--column-heading">Rate Type</span>
            </div>
          }
          <div className="parkchirp--carryover-entry-table--net-amount-column parkchirp--carryover-entry-table--cell">
            <span className="parkchirp--carryover-entry-table--column-heading">Net Amount</span>
          </div>
          <div className="parkchirp--carryover-entry-table--amount-tax-1-column parkchirp--carryover-entry-table--cell">
            <span className="parkchirp--carryover-entry-table--column-heading">Tax 1</span>
          </div>
          <div className="parkchirp--carryover-entry-table--amount-tax-2-column parkchirp--carryover-entry-table--cell">
            <span className="parkchirp--carryover-entry-table--column-heading">Tax 2</span>
          </div>
          <div className="parkchirp--carryover-entry-table--amount-tax-3-column parkchirp--carryover-entry-table--cell">
            <span className="parkchirp--carryover-entry-table--column-heading">Tax 3</span>
          </div>
          <div className="parkchirp--carryover-entry-table--amount-tax-4-column parkchirp--carryover-entry-table--cell">
            <span className="parkchirp--carryover-entry-table--column-heading">Tax 4</span>
          </div>
          <div className="parkchirp--carryover-entry-table--gross-amount-column parkchirp--carryover-entry-table--cell">
            <span className="parkchirp--carryover-entry-table--column-heading">Gross Amount</span>
          </div>
        </header>


        {featureFlags.CARRYOVER_RATE &&
          <div className="parkchirp--carryover-entry-table--body">
            {lineItems.map((lineItem, lineItemIndex) => {
              return (
                lineItem.fields.entries.value.map((lineItemEntry, lineItemEntryIndex) => {
                  const grossAmountValue = lineItemEntry.getGrossAmount();
                  return (
                    <div className="parkchirp--carryover-entry-table--row" id="parkchirp--carryover-entry-table--row-line-items" key={`parkchirp-carryover-row-${lineItemEntryIndex}`}>
                      <div className="parkchirp--carryover-entry-table--row--line-item-container">

                        <div className="parkchirp--carryover-entry-table--line-item-rate-type-column parkchirp--carryover-entry-table--cell">
                          <InputSelectField inputId={`${inputId}--line_item_rate_type`}
                            key='rate-type--1'
                            options={lineItemConfig.line_item_rate_type.options}
                            value={lineItem.fields.line_item_rate_type.value}
                            onChange={ this._onLineItemValueChange(lineItemIndex, 'line_item_rate_type') }
                            editMode={ true }
                          />
                        </div>

                        <div className="parkchirp--carryover-entry-table--net-amount-column parkchirp--carryover-entry-table--cell">
                          <InputCurrencyField inputId={`${inputId}--amount`}
                            key={`amount--${lineItemEntry.fields.amount.value}`}
                            value={lineItemEntry.fields.amount.value}
                            onChange={this._onLineItemEntryValueChange('amount', lineItemIndex, lineItemEntryIndex)}
                            editMode={true}
                            checkNegative={true}
                            validator={this.amountValidator}
                            validatorText={this.amountValidatorText}
                          />
                        </div>
                        <div className="parkchirp--carryover-entry-table--amount-tax-1-column parkchirp--carryover-entry-table--cell">
                          <InputCurrencyField inputId={`${inputId}--amount-tax-1`}
                            key={`amount--${lineItemEntry.fields.amount_tax_1.value}`}
                            value={lineItemEntry.fields.amount_tax_1.value}
                            onChange={this._onLineItemEntryValueChange('amount_tax_1', lineItemIndex, lineItemEntryIndex)}
                            editMode={true}
                            checkNegative={true}
                            validator={this.amountValidator}
                            validatorText={this.amountValidatorText}
                            disabledMode={taxExempt}
                          />
                        </div>
                        <div className="parkchirp--carryover-entry-table--amount-tax-2-column parkchirp--carryover-entry-table--cell">
                          <InputCurrencyField inputId={`${inputId}--amount_tax_2`}
                            key={`balance--${lineItemEntry.fields.amount_tax_2.value}`}
                            value={lineItemEntry.fields.amount_tax_2.value}
                            onChange={this._onLineItemEntryValueChange('amount_tax_2', lineItemIndex, lineItemEntryIndex)}
                            editMode={true}
                            checkNegative={true}
                            validator={this.amountValidator}
                            validatorText={this.amountValidatorText}
                            disabledMode={taxExempt}
                          />
                        </div>
                        <div className="parkchirp--carryover-entry-table--amount-tax-3-column parkchirp--carryover-entry-table--cell">
                          <InputCurrencyField inputId={`${inputId}--amount_tax_3`}
                            key={`balance--${lineItemEntry.fields.amount_tax_3.value}`}
                            value={lineItemEntry.fields.amount_tax_3.value}
                            onChange={this._onLineItemEntryValueChange('amount_tax_3', lineItemIndex, lineItemEntryIndex)}
                            editMode={true}
                            checkNegative={true}
                            validator={this.amountValidator}
                            validatorText={this.amountValidatorText}
                            disabledMode={taxExempt}
                          />
                        </div>
                        <div className="parkchirp--carryover-entry-table--amount-tax-4-column parkchirp--carryover-entry-table--cell">
                          <InputCurrencyField inputId={`${inputId}--amount_tax_4`}
                            key={`balance--${lineItemEntry.fields.amount_tax_4.value}`}
                            value={lineItemEntry.fields.amount_tax_4.value}
                            onChange={this._onLineItemEntryValueChange('amount_tax_4', lineItemIndex, lineItemEntryIndex)}
                            editMode={true}
                            checkNegative={true}
                            validator={this.amountValidator}
                            validatorText={this.amountValidatorText}
                            disabledMode={taxExempt}
                          />
                        </div>
                        <div className="parkchirp--carryover-entry-table--cell parkchirp--carryover-gross-amount-width">
                          <InputCurrencyField inputId={`${inputId}--gross-amount`}
                            key={`gross-amount--${grossAmountValue}`}
                            value={grossAmountValue}
                            editMode={false}
                            validator={this.grossValidator}
                          />
                        </div>
                        {newMode && lineItems.length > 1 &&
                          <div className="parkchirp--carryover-entry-table--cell parkchirp--carryover-delete">
                            <button id={`line-item-delete${lineItemIndex}`} type="button" onClick={() => this.handleDeleteLineItem(lineItemIndex)}>Delete</button>
                          </div>
                        }
                      </div>
                    </div>
                  );
                }))
            })}

            {lineItems.length < 10 &&
              <div className="parkchirp--carryover-entry-table--row ">
                <div className="parkchirp--carryover-entry-table--row--line-item-container">
                  <div className="parkchirp--carryover-entry-table--cell">
                    <button type="button"
                      className="parkchirp--button-as-link"
                      onClick={this._onAddLineItemClick}>
                      Add Line Item
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }

        {!featureFlags.CARRYOVER_RATE &&
          <div className="parkchirp--carryover-entry-table--body">
            {lineItems.fields.entries.value.map((lineItemEntry, index) => {
              const grossAmountValue = lineItemEntry.getGrossAmount();
              return (
                <div className="parkchirp--carryover-entry-table--row">
                  <div className="parkchirp--carryover-entry-table--row--line-item-container">
                    <div className="parkchirp--carryover-entry-table--net-amount-column parkchirp--carryover-entry-table--cell">
                      <InputCurrencyField inputId={`${inputId}--amount`}
                        key={`amount--${lineItemEntry.fields.amount.value}`}
                        value={lineItemEntry.fields.amount.value}
                        onChange={this._onLineItemEntryValueChange('amount', 0, index)}
                        editMode={true}
                        validator={this.amountValidator}
                        validatorText={this.amountValidatorText}
                      />
                    </div>
                    <div className="parkchirp--carryover-entry-table--amount-tax-1-column parkchirp--carryover-entry-table--cell">
                      <InputCurrencyField inputId={`${inputId}--amount-tax-1`}
                        key={`amount--${lineItemEntry.fields.amount_tax_1.value}`}
                        value={lineItemEntry.fields.amount_tax_1.value}
                        onChange={this._onLineItemEntryValueChange('amount_tax_1', 0, index)}
                        editMode={true}
                        validator={this.amountValidator}
                        validatorText={this.amountValidatorText}
                      />
                    </div>
                    <div className="parkchirp--carryover-entry-table--amount-tax-2-column parkchirp--carryover-entry-table--cell">
                      <InputCurrencyField inputId={`${inputId}--amount_tax_2`}
                        key={`balance--${lineItemEntry.fields.amount_tax_2.value}`}
                        value={lineItemEntry.fields.amount_tax_2.value}
                        onChange={this._onLineItemEntryValueChange('amount_tax_2', 0, index)}
                        editMode={true}
                        validator={this.amountValidator}
                        validatorText={this.amountValidatorText}
                      />
                    </div>
                    <div className="parkchirp--carryover-entry-table--amount-tax-3-column parkchirp--carryover-entry-table--cell">
                      <InputCurrencyField inputId={`${inputId}--amount_tax_3`}
                        key={`balance--${lineItemEntry.fields.amount_tax_3.value}`}
                        value={lineItemEntry.fields.amount_tax_3.value}
                        onChange={this._onLineItemEntryValueChange('amount_tax_3', 0, index)}
                        editMode={true}
                        validator={this.amountValidator}
                        validatorText={this.amountValidatorText}
                      />
                    </div>
                    <div className="parkchirp--carryover-entry-table--amount-tax-4-column parkchirp--carryover-entry-table--cell">
                      <InputCurrencyField inputId={`${inputId}--amount_tax_4`}
                        key={`balance--${lineItemEntry.fields.amount_tax_4.value}`}
                        value={lineItemEntry.fields.amount_tax_4.value}
                        onChange={this._onLineItemEntryValueChange('amount_tax_4', 0, index)}
                        editMode={true}
                        validator={this.amountValidator}
                        validatorText={this.amountValidatorText}
                      />
                    </div>
                    <div className="parkchirp--carryover-entry-table--gross-amount-column parkchirp--carryover-entry-table--cell">
                      <InputCurrencyField inputId={`${inputId}--gross-amount`}
                        key={`gross-amount--${grossAmountValue}`}
                        value={grossAmountValue}
                        editMode={false}
                        validator={this.grossValidator}
                        validatorText={this.grossValidatorText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        }
      </div>
    );
  }
};

export default NewCarryoverLineItemPanel;
